import { render, staticRenderFns } from "./CareerCategoryCriteriaFormField.vue?vue&type=template&id=44c38836&scoped=true"
import script from "./CareerCategoryCriteriaFormField.vue?vue&type=script&lang=ts"
export * from "./CareerCategoryCriteriaFormField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c38836",
  null
  
)

export default component.exports